import { createContext, useContext } from "react";
import type { ReportOrientation } from "store/types";

interface CardSizeContextValue {
  widthPercent: number;
  heightPx?: number;
  topOffsetPx?: number;
  leftOffsetPx?: number;
  orientation: ReportOrientation;
  isEditMode: boolean;
}

const CardSizeContext = createContext<CardSizeContextValue>({
  widthPercent: 100,
  orientation: "portrait",
  isEditMode: true,
});

export const CardSizeProvider = CardSizeContext.Provider;
export function useCardSize() {
  return useContext(CardSizeContext);
}
